import React, { useCallback, useRef } from 'react';

function useClickOutside(cb) {
    const ref = useRef();
    const handleClickOutside = useCallback(
        (e) => {
            if (ref?.current && e && !ref.current.contains(e.target)) {
                cb();
            }
        },
        [cb]
    );

    React.useEffect(() => {
        const iframe = document.getElementById('dorik-builder-iframe');
        if (iframe) {
            const iDoc = iframe.contentWindow || iframe.contentDocument;
            iDoc.addEventListener('click', handleClickOutside);
        }
        document.addEventListener('click', handleClickOutside);

        // Clearn up
        return () => {
            if (iframe) {
                const iDoc = iframe.contentWindow || iframe.contentDocument;
                iDoc.removeEventListener('click', handleClickOutside);
            }
            document.removeEventListener('click', handleClickOutside);
        };
    }, [handleClickOutside]);

    return ref;
}

export default useClickOutside;
